import { InboxArrowDownIcon } from '@heroicons/react/24/outline';
import React, { useState, useCallback } from 'react';

import AppLayout from '../../components/AppLayout';

import BulkOperationList from './components/BulkUploadList';
import CreateBulkOperationModal from './components/CreateImportModal';
import { useBulkOperations } from './hooks/useImports';

const BulkUploadPage: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const { bulkOperations, loading, error, refreshBulkOperations } =
    useBulkOperations();

  return (
    <AppLayout>
      <div className='p-4'>
        <div className='max-w-7xl mx-auto'>
          {/* Page Header */}
          <div className='mb-6'>
            <h1 className='text-3xl font-bold text-gray-900 dark:text-gray-50 mb-2'>
              Bulk Upload
            </h1>
            <p className='text-gray-600 dark:text-gray-400'>
              Upload multiple PDF files at once and automatically generate
              booking data for all of them.
            </p>
          </div>

          {/* New Bulk Upload Button */}
          <div className='mb-6'>
            <button
              onClick={() => setIsModalOpen(true)}
              className='flex items-center px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200 font-medium'
            >
              <InboxArrowDownIcon className='w-5 h-5 mr-2' />
              New Bulk Upload
            </button>
          </div>

          {/* Bulk Operation List */}
          <BulkOperationList
            bulkOperations={bulkOperations}
            loading={loading}
            error={error}
            onRefresh={refreshBulkOperations}
          />
        </div>
      </div>

      {/* Create Bulk Operation Modal */}
      <CreateBulkOperationModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
      />
    </AppLayout>
  );
};

export default BulkUploadPage;
